import React, { useState, useCallback, useEffect } from 'react';
import { Link, useRouter } from './../util/router';
import { useAuth } from './../util/auth';
import { ChevronDownIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { getProfilePhoto } from '../util/util';

/**
 * Avatar + account dropdown (shared by Navbar and feed layout).
 */
const NavbarProfileMenu = () => {
  const auth = useAuth();
  const router = useRouter();
  const signinPath = `/auth/signin?next=${encodeURIComponent(
    `${router.location.pathname}${router.location.search}`
  )}`;
  const [userPhoto, setUserPhoto] = useState();

  const navigation = [
    { name: 'Featured Lists', href: '/featured' },
    { name: 'My Lists', href: '/my-lists' },
    { name: 'My Profile', href: `/profile/${auth.user?.username}` },
    { name: 'Account Settings', href: '/settings/general' },
    { name: 'About', href: '/about' },
  ];

  const fetchProfilePhoto = useCallback(async () => {
    try {
      if (auth.user) {
        const photo = await getProfilePhoto(auth.user.id);
        setUserPhoto(photo);
      }
    } catch (error) {
      console.error(error);
    }
  }, [auth.user]);

  useEffect(() => {
    fetchProfilePhoto();
  }, [fetchProfilePhoto]);

  return (
    <div className="dropdown dropdown-bottom dropdown-end relative z-[120] shrink-0">
      <div
        tabIndex={0}
        role="button"
        aria-haspopup="menu"
        className="flex cursor-pointer items-center gap-0.5 rounded-full pr-0.5 outline-none focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-secondary-red/50 sm:gap-1"
      >
        <div className="avatar shrink-0">
          <div className="w-8 rounded-full">
            {userPhoto ? (
              <img className="h-full w-full object-cover" src={userPhoto} alt="" />
            ) : (
              <UserCircleIcon className="h-8 w-8" />
            )}
          </div>
        </div>
        <ChevronDownIcon
          className="h-5 w-5 shrink-0 text-slate-400"
          aria-hidden
          strokeWidth={2}
        />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu z-[110] max-md:w-[calc(100vw-2rem)] max-md:max-w-[calc(100vw-2rem)] max-md:max-h-[min(70vh,calc(100vh-6rem))] max-md:overflow-y-auto md:w-52 rounded-box bg-white p-2 text-base shadow"
      >
        {auth.user ? (
          navigation.map(item => (
            <li key={item.name}>
              <Link to={item.href}>{item.name}</Link>
            </li>
          ))
        ) : (
          <li key="About">
            <Link to="/about">About</Link>
          </li>
        )}
        {!auth.user ? (
          <li className="py-1">
            <Link to={signinPath} className="font-semibold text-gray-900">
              Sign in <span aria-hidden="true">&rarr;</span>
            </Link>
          </li>
        ) : (
          <li className="py-1">
            <Link
              to="auth/signout"
              className="font-semibold text-secondary-red"
              onClick={e => {
                e.preventDefault();
                auth.signout();
              }}
            >
              Sign out <span aria-hidden="true">&rarr;</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default NavbarProfileMenu;
